import React from "react";

interface TimerBarProps {
  remainingTime: number;
  totalTime: number;
}

const TimerBar: React.FC<TimerBarProps> = ({ remainingTime, totalTime }) => {
  const percentage = (remainingTime / totalTime) * 100;

  const barColor =
    percentage > 50
      ? "bg-green-500"
      : percentage > 25
      ? "bg-yellow-500"
      : "bg-red-500";

  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5 my-4 shadow-inner">
      <div
        className={`h-2.5 rounded-full transition-all duration-100 ease-linear ${barColor}`}
        style={{ width: `${percentage}%` }}
      ></div>
    </div>
  );
};

export default TimerBar;
